import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson16 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  let a = 10;
  let b = 5;
  console.log(a + b); // Output: 15
  console.log(a - b); // Output: 5
  console.log(a * b); // Output: 50
  console.log(a / b); // Output: 2
  console.log(a % b); // Output: 0
  console.log(a++);   // Output: 10 (a incremented to 11)
  console.log(b--);   // Output: 5 (b decremented to 4)

  `
  );
  const code2 = (
  'text',
  `
  let x = 10;
  let y = 5;

  x += y; // Equivalent to: x = x + y (x becomes 15)
  y *= 2; // Equivalent to: y = y * 2 (y becomes 10)

  `
  );
  const code3 = (
  'text',
  `
  let p = 10;
  let q = 5;

  console.log(p == q);  // Output: false
  console.log(p === q); // Output: false (checks both value and type)
  console.log(p != q);  // Output: true
  console.log(p > q);   // Output: true
  console.log(p <= q);  // Output: false

  `
  );
  const code4 = (
  'text',
  `
  let raining = true;
  let umbrella = true;

  if (raining && umbrella) {
      console.log("Take an umbrella"); // Output: Take an umbrella
  }


  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <div className="alert alert-secondary" role="alert">
    <h3><strong>1. Arithmetic Operators:</strong></h3>
      <ul class="list-group list-group-numbered">
        <li class="list-group-item">Addition (+)</li>
        <li class="list-group-item">Subtraction (-)</li>
        <li class="list-group-item">Multiplication (*)</li>
        <li class="list-group-item">Division (/)</li>
        <li class="list-group-item">Modulus (%) </li>
        <li class="list-group-item">Increment (++) </li>
        <li class="list-group-item">Decrement (--) </li>
      </ul>
      <br />
      <CopyBlock
      language={language}
      text={code}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
      />
      </div>

      <div className="alert alert-secondary" role="alert">
      <h3><strong>2. Assignment Operators:</strong></h3>
        <ul class="list-group list-group-numbered">
          <li class="list-group-item">Simple Assignment (=)</li>
          <li class="list-group-item">Add and assignment (+=)</li>
          <li class="list-group-item">Subtract and assignment (-=)</li>
          <li class="list-group-item">Multiply and assignment (*=)</li>
          <li class="list-group-item">Divide and assignment (/=)</li>
          <li class="list-group-item">Modulus and assignment (%=) </li>
        </ul>
        <br />
        <CopyBlock
        language={language}
        text={code2}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>

      <div className="alert alert-secondary" role="alert">
      <h3><strong>3. Comparison Operators:</strong></h3>
        <ul class="list-group list-group-numbered">
          <li class="list-group-item">Equal to (==)</li>
          <li class="list-group-item">Strict Equal to (===)</li>
          <li class="list-group-item">Not equal to (!= or !==)</li>
          <li class="list-group-item">Greater than (&lt;)</li>
          <li class="list-group-item">Less than (&gt;)</li>
          <li class="list-group-item">Greater than or equal to (&gt;=)</li>
          <li class="list-group-item">Less than or equal to (&lt;=) </li>
        </ul>
        <br />
        <CopyBlock
        language={language}
        text={code3}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>

        <div className="alert alert-secondary" role="alert">
        <h3><strong>4. Logical Operators:</strong></h3>
          <ul class="list-group list-group-numbered">
            <li class="list-group-item">Logical AND (&&)</li>
            <li class="list-group-item">Logical OR (||)</li>
            <li class="list-group-item">Logical NOT (!)</li>
          </ul>
          <br />
          <CopyBlock
          language={language}
          text={code4}
          showLineNumbers={lineNumbers}
          theme={dracula}
          wrapLines={true}
          codeBlock
          />
          </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson16
